if (!customElements.get("product-message")) {
  class t extends HTMLElement {
    constructor() {
      super(), this.closeButton = this.querySelector(".js-close-message"), this.openInEditor = !1,
        this.init(), this.bindEvents()
    }
    disconnectedCallback() {
      this.blockSelectHandler && document.removeEventListener("shopify:block:select", this
        .blockSelectHandler), this.blockDeselectHandler && document.removeEventListener(
        "shopify:block:deselect", this.blockDeselectHandler)
    }
    init() {
      let t = !1;
      if (this.dataset.persistentClose && !Shopify.designMode) {
        let e = theme.storageUtil.get("closed-messages", !0) || [];
        e && e.includes(this.dataset.blockId) && (t = !0, this.remove())
      }
      this.classList.contains("product-message--out") && (!t || Shopify.designMode) && (this.show(
        !this.dataset.transient), this.dataset.transient && setTimeout(() => {
        this.openInEditor || this.hide(!1)
      }, 1e3 * this.dataset.transient))
    }
    bindEvents() {
      this.closeButton && this.closeButton.addEventListener("click", this.handleCloseClick.bind(
        this)), Shopify.designMode && this.dataset.transient && (this.blockSelectHandler = this
        .handleBlockSelect.bind(this), this.blockDeselectHandler = this.handleBlockDeselect
        .bind(this), document.addEventListener("shopify:block:select", this.blockSelectHandler),
        document.addEventListener("shopify:block:deselect", this.blockDeselectHandler))
    }
    handleBlockSelect(t) {
      t.target.classList.contains("product-message") && t.target.dataset.transient && (this
        .openInEditor = !0, this.show(!0))
    }
    handleBlockDeselect(t) {
      t.target.classList.contains("product-message") && t.target.dataset.transient && (this
        .openInEditor = !1, this.hide(!0), theme.storageUtil.remove("closed-messages"))
    }
    handleCloseClick() {
      if (this.dataset.persistentClose) {
        let t = theme.storageUtil.get("closed-messages", !0) || [];
        t.includes(this.dataset.blockId) || (t.push(this.dataset.blockId), theme.storageUtil.set(
          "closed-messages", t))
      }
      this.hide(!0)
    }
    show(t) {
      t && (this.style.transitionDelay = "0s", this.style.transitionDuration = "0s"), this
        .classList.remove("product-message--out")
    }
    hide(t) {
      t && (this.style.transitionDelay = "0s", this.style.transitionDuration = "0.2s", this.style
        .filter = "opacity(0)", this.style.pointerEvents = "none"), this.classList.contains(
        "product-message--info") ? (this.style.maxHeight =
        `${this.getBoundingClientRect().height+10}px`, setTimeout(() => {
          this.classList.add("product-message--out")
        })) : this.classList.add("product-message--out")
    }
  }
  customElements.define("product-message", t)
}
